import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faXmark} from "@fortawesome/pro-solid-svg-icons/faXmark";
import {ColourSolid} from "@twigsby/frontend-framework";
import React from "react";

export interface FilterItemType {
    content: any;
    colour?: ColourSolid;
    callback?: any;
}

const FilterItem = (props: FilterItemType) => {
    return (
        <div
            className={`filter-item ${props.colour ? props.colour : ''}`}
        >
            {props.content}
            {props.callback && (
                <div tabIndex={0} className={'filter-item-action'} onClick={() => props.callback()}><FontAwesomeIcon icon={faXmark} fixedWidth={true} /></div>
            )}
        </div>
    )
}

export default FilterItem
